export default "__VITE_ASSET__D4FeI8_J__"